<dx-popup
    #sharedWorkspaces
    width="50%"
    height="40%"
    title="Shared Workspaces"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onShown)="onShown($event)"
    (onHidden)="onHidden($event)"
>
    <div *dxTemplate="let data of 'content'" class="shared-workspaces-content">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <dx-data-grid
                    width="100%"
                    height="100%"
                    class="cc-vertical-center-cell-data-grid"
                    [dataSource]="sharedWorkspaceResults"
                    [allowColumnReordering]="true"
                    [allowColumnResizing]="true"
                    [columnAutoWidth]="true"
                    [showBorders]="true"
                    [showColumnLines]="true"
                    [showRowLines]="true"
                    noDataText="No shared workspaces to display"
                >
                    <dxi-column type="buttons" caption="" [width]="120">
                        <dxi-button template="template">
                            <div *dxTemplate="let row of 'template'" class="cc-action-button">
                                <dx-drop-down-button
                                    class="dropdown-button icon-button-content"
                                    text="Actions"
                                    icon="runner"
                                    dropDownContentTemplate="dropDownContentTemplate"
                                    [showArrowIcon]="true"
                                    [visible]="hasVisibleAction(row.data)"
                                >
                                    <div
                                        *dxTemplate="let content of 'dropDownContentTemplate'"
                                        class="content-container"
                                    >
                                        <div class="option-menu" *ngFor="let item of actionItems">
                                            <ng-container *ngIf="isActionVisible(item, row.data)">
                                                <dx-button
                                                    class="dropdown-menu-button"
                                                    [width]="200"
                                                    [type]="item.type"
                                                    [text]="item.text"
                                                    [icon]="item.icon"
                                                    (click)="onActionClick(item, row.data)"
                                                ></dx-button>
                                            </ng-container>
                                        </div>
                                    </div>
                                </dx-drop-down-button>
                            </div>
                        </dxi-button>
                    </dxi-column>
                    <dxi-column dataField="name" dataType="string" caption="Workspace Name"></dxi-column>
                    <dxi-column
                        dataField="createdBy.displayName"
                        dataType="string"
                        caption="Created By"
                        cellTemplate="userBioTemplate"
                    ></dxi-column>
                    <dxi-column
                        dataField="createdDate"
                        dataType="date"
                        caption="Created Date"
                        [format]="dateFormat"
                        [width]="100"
                    ></dxi-column>

                    <div *dxTemplate="let row of 'userBioTemplate'">
                        <app-user-bio-link
                            [user]="row.data.createdBy"
                            [communityId]="selectedContext?.communityId"
                        ></app-user-bio-link>
                    </div>
                </dx-data-grid>
            </dxi-item>
            <dxi-item baseSize="auto">
                <dx-button
                    type="default"
                    text="Close"
                    hint="Close"
                    [icon]="iconClose"
                    [width]="80"
                    (onClick)="onHidden($event)"
                ></dx-button>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#sharedWorkspaces' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
